angular.module("digitalLeasing.module").component("ratingDetail", {
    templateUrl: "ng/components/digitalLeasing/ratingDetail/ratingDetail.view.html",
    bindings: {
        model: "=",
        exportValidityRatingCgs: "&",
        snapshot: '<'
    },
    controllerAs: "ratingDetailCtrl",
    controller: function RatingDetail($financialApiService, Riferimenti) {
        var self = this;

        self.$onInit = function () {
            jQuery(".alb-scroll.recovery-scroll").mCustomScrollbar("scrollTo", 0); //posiziona la scollBar in top ad ogni cambio vista - 
            self.isPending = true;
            // self.confirm = false;
            self.populateContacts = 0;
            self.checkContatti();

            if (!self.snapshot) {
                $financialApiService.getRatingCgs(self.model.leasingData.preventivo.questionarioNuovoPrestoleasing, self.model.financialCustomer.metadata.riUserG.cf,
                    self.model.financialVendor.filiale.abi)
                    .then(function (response) {
                        self.ratingCustomer = response.ratingCgs;
                        self.percentualeGaranzia = response.percentualeGaranzia;
                        self.model.leasingData.preventivo.deliberaBanca.percentualeGaranziaBanca = response.percentualeGaranzia;
                        self.percentualeGaranziaPredefinita = response.percentualeGaranziaPredefinita
                        self.message = response.message ? response.message : ''
                        self.model.leasingData.preventivo.ratingCgs = response.ratingCgs;
                        self.isPending = false;
                    })
            } else {
                self.ratingCustomer = self.model.leasingData.preventivo.ratingCgs;
                self.percentualeGaranzia = self.model.leasingData.preventivo.deliberaBanca.percentualeGaranziaBanca;
                self.isPending = false;
            }



        };

        self.getBank = function (model) {
            $financialApiService
                .getContattiAra(model.ndg)
                .then(function (response) {
                    console.log("getContacts_bank: ", response);
                    if (response && response.riferimenti && response.riferimenti[0]) {
                        var contactUser = self.model.leasingData.preventivo.contatti.riferimenti
                            .find(function (element) {
                                return element.id == "BANCA"
                            });

                        contactUser.description = response.riferimenti[0].description;
                        contactUser.email = response.riferimenti[0].email;
                        contactUser.telefono = response.riferimenti[0].telefono;
                        self.populateContacts = self.populateContacts + 1;
                    }
                }).catch(function (error) {
                    console.error(error);
                });
        }

        self.getCustomer = function (model) {
            $financialApiService
                .getContattiCliente(model.riUserG, self.model.leasingData.id)
                .then(function (response) {
                    console.log("getContacts_customer: ", response);
                    if (response && response.riferimenti && response.riferimenti[0]) {
                        var contactCustomer = self.model.leasingData.preventivo.contatti.riferimenti
                            .find(function (element) { return (element.id == "CLIENTE") });

                        contactCustomer.description = response.riferimenti[0].description;
                        contactCustomer.email = response.riferimenti[0].email;
                        contactCustomer.telefono = response.riferimenti[0].telefono;
                        self.populateContacts = self.populateContacts + 1;
                    }
                }).catch(function (error) {
                    console.error(error);
                });
        }

        self.askForSelection = function (selection) {
            if (selection) {
                self.confirm = selection;
                self.ratingSelectionIsOk = true;
                self.model.leasingData.preventivo.confermaPrestoLeasing = true;
            } else {
                self.ratingSelectionIsOk = false;
                self.model.leasingData.preventivo.confermaPrestoLeasing = false;
            }

            self.check();
        }

        self.ratingIsOk = function (validity) {
            self.rating = validity;
            self.check()
        }

        self.componentIsOk = function () {
            self.financialContactsIsOk = true;
            self.check();
        }

        self.componentIsNotOk = function () {
            self.financialContactsIsOk = false;
            self.check();
        }

        self.check = function () {
            if (self.financialContactsIsOk && self.rating) {
                self.validityRatingCgs(true);
            } else {
                self.validityRatingCgs(false)
            }
        }

        self.validityRatingCgs = function (validity) {
            self.exportValidityRatingCgs({
                validity: validity
            });
        }

        self.checkContatti = function () {
            if (!self.model.leasingData.preventivo.contatti.riferimenti.length) {
                self.customer = Riferimenti.build({ id: "CLIENTE" })
                self.bank = Riferimenti.build({ id: "BANCA" })
                self.model.leasingData.preventivo.contatti.riferimenti = [self.customer, self.bank];
                self.getBank(self.model.financialVendor.riUserG);
                self.getCustomer(self.model.financialCustomer.metadata);
            } else {
                self.model.leasingData.preventivo.contatti.riferimenti.forEach(function (element) {
                    if (element.id == "BANCA") {
                        self.bankPresent = true;
                    } else if (element.id == "CLIENTE") {
                        self.clientePresent = true;
                    }
                })
                if (!self.bankPresent) {
                    self.bank = Riferimenti.build({ id: "BANCA" })
                    self.model.leasingData.preventivo.contatti.riferimenti.push(self.bank);
                    self.getBank(self.model.financialVendor.riUserG);
                } else if (!self.clientePresent) {
                    self.customer = Riferimenti.build({ id: "CLIENTE" })
                    self.model.leasingData.preventivo.contatti.riferimenti.push(self.customer);
                    self.getCustomer(self.model.financialCustomer.metadata);
                }
            }
        }
    }
});